module.exports = __webpack_public_path__ + "img/appAsset-ui-graphLineNoneData.985d7740.svg";